export const groupBy = (xs, key) => {
  return xs.reduce((rv, x) => {(rv[x[key]] = rv[x[key]] || []).push(x); return rv;}, {});
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};